import React from 'react';
import { ZoomClient } from '../types/index-types';
export default React.createContext<ZoomClient>(null as any);
